/* unplugin-vue-components disabled */import script from "./DispatchConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./DispatchConfig.vue?vue&type=script&setup=true&lang=js"

import "./DispatchConfig.vue?vue&type=style&index=0&id=64f98f58&lang=scss"

const __exports__ = script;

export default __exports__